import type { ComponentProps } from 'react'

import styled from 'styled-components'

export type LineClampProps = Omit<ComponentProps<'span'>, 'ref'> & {
  lines?: number
  textOverflow?: 'ellipsis' | 'clip'
}

const Content = styled.span<Pick<LineClampProps, 'lines' | 'textOverflow'>>`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.lines ?? 1};
  text-overflow: ${(props) => props.textOverflow ?? 'ellipsis'};
`

const LineClamp = ({
  children,
  className,
  lines = 1,
  textOverflow = 'ellipsis',
  ...rest
}: LineClampProps) => {
  return (
    <Content lines={lines} textOverflow={textOverflow} className={className} {...rest}>
      {children}
    </Content>
  )
}

export default LineClamp
